export * from './discounts';
export * from './formats';
export * from './platform';

/** Width of the side drawer */
export const drawerWidth = 313;

export const CONTACT_ACC_MANAGER_SUBJECT = {
  OPENING_HOURS: 'Update opening hours',
  UPDATE_PROFILE: 'Update menus or photos',
  UPDATE_DEALS: 'Update offers',
  OTHER: 'Other',
};

export const CANCEL_REASON_TRACKING = {
  sold_business: 'Sold Business',
  closed_permanently: 'Closed Business Permanently',
  eatclub_customer_issues: 'Issues with EatClub Customers',
  pause_membership: 'Pause Due to Renovation or Staff Shortage',
  not_getting_value: 'Not Getting Expected Value',
  financial_difficulty: 'Financial Difficulty',
  technical_issues: 'Technical Issues',
  struggling_to_make_enough_margin_after_offer: 'Struggling to Make Margin',
  not_getting_enough_orders: 'Not Getting Enough Orders',
  fees_are_too_high: 'Fees Are Too High',
};
